te<template>
  <v-main>
    <v-card class="idcs-dialog-back fill-height">
      <v-card-actions>
        <v-subheader>{{ $t("rec_types.UserRecord") }}</v-subheader>
        <v-spacer></v-spacer>
        <v-btn icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-actions>
      <v-card-text>
        <v-form ref="form" :lazy-validation="true">
          <v-row>
            <v-col cols="3">
              <v-text-field
                v-model="item.id"
                :label="$t('field.name')"
                :disabled="!clone"
                :rules="required"
                shaped
                outlined
                background-color="yellow lighten-5"
                color="black"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-select
                :items="[{'value': 4, 'text': $t('admin.newcmsonly') }, ...$t('recStatus')]"
                :label="$t('field.status')"
                shaped
                outlined
                background-color="yellow lighten-5"
                color="black"
                v-model="item.status"
                required
              ></v-select>
            </v-col>
            <v-col cols="3">
              <v-text-field
                v-model="item.password"
                :label="$t('field.password')"
                :type="show2 ? 'text' : 'password'"
                :disabled="!clone"
                outlined
                shaped
                background-color="yellow lighten-5"
                color="black"
                prepend-icon="mdi-pencil"
                :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="show2 = !show2"
                @click:prepend="generatePass"
                :rules="password"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-select
                :items="$store.getters['admin/groups']"
                :label="$t('field.user_group')"
                item-text="id"
                item-value="id"
                shaped
                outlined
                background-color="yellow lighten-5"
                color="black"
                v-model="item.userGroup"
                :rules="required"
                clearable
                :disabled="!group"
              ></v-select>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="item.additional"
                outlined
                shaped
                background-color="yellow lighten-5"
                color="black"
                :label="$t('field.additional')"
              ></v-text-field>
            </v-col>
            <v-col cols="5">
              <v-tooltip bottom>
                <template #activator="{on, attrs}">
                  <div v-bind="attrs" v-on="on">
                    <v-autocomplete
                      prepend-inner-icon="fa-store"
                      :label="$t('field.subcompany')"
                      v-model="subcompany"
                      background-color="yellow lighten-5"
                      color="black"
                      shaped
                      outlined
                      clearable
                      return-object
                      :placeholder="$t('search.all')"
                      :items="$store.getters['struct/subcompanies']"
                      class="width-fit"
                    ></v-autocomplete>
                  </div>
                </template>
                <i18n path="tooltip.scFilter" />
              </v-tooltip>
            </v-col>
            <v-col cols=4>
              <v-text-field
                v-model="email"
                outlined
                shaped
                background-color="yellow lighten-5"
                color="black"
                :label="$t('card.prof.email')"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="item.sysData"
                outlined
                shaped
                background-color="yellow lighten-5"
                color="black"
                :label="$t('field.sysdata')"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              {{ $t("field.created") + ":" }}
              <small>{{ item.created }}</small>
            </v-col>
            <v-col cols="6" class="text-right">
              {{ $t("field.modified") + ":" }}
              <small>{{ item.lastModified }}</small>
            </v-col>
            <v-col cols="12">
              <v-alert
                v-model="showAlert"
                border="left"
                colored-border
                type="error"
                elevation="2"
                :dismissible="true"
                transition="fade-transition"
              >{{ alertMessage }}</v-alert>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn
          v-if="!clone"
          color="blue darken-1"
          text
          @click="simpleDialog = true"
        >{{ $t("button.delete") }}</v-btn>
        <v-spacer></v-spacer>
        <v-btn
          v-if="!clone"
          color="blue darken-1"
          text
          @click="group = true"
        >{{ $t("button.switch_group") }}</v-btn>
        <v-btn
          v-if="!clone"
          color="blue darken-1"
          text
          @click="clone = true"
        >{{ $t("button.clone") }}</v-btn>
        <v-btn color="blue darken-1" text @click="save(true)">{{ $t("button.save") }}</v-btn>
      </v-card-actions>
    </v-card>
    <DeleteDialog v-model="simpleDialog" @click:ok="erase" />
  </v-main>
</template>
<script>
//import axios from "axios";
import app from "@/app.js";
import password from "@/password.js";
import DeleteDialog from "@/components/DeleteDialog.vue";

const rec_type = "UserRecord";

export default {
  name: "UserEditor",
  components: { DeleteDialog },
  props: {
    record: { type: Object, required: true },
    value: { type: Boolean },
    newuser: { type: Boolean, default: false },
  },
  data() {
    return {
      show2: false,
      simpleDialog: false,
      showAlert: false,
      clone: this.newuser,
      group: false,
      alertMessage: "",
      password: [
        (v) => !!v || this.$t("error.required"),
        (v) => (v && v.length >= 4) || this.$t("error.pswlength"),
      ],
      required: [(v) => !!v || this.$t("error.required")],
      item: { ...this.record },
    };
  },
  watch: {
    record: {
      handler(nw) {
        this.item = { ...this.record };
        this.clone = false;
        this.show2 = false;
        this.group = false;
        if (!nw.id) {
          this.clone = true;
          this.show2 = true;
        }
        //     console.log("watch", this.item);
      },
      deep: true,
    },
  },
  computed: {
    subcompany: {
      get() {
        try {
          return app.getRule(this.item.sysData, "sc", "");
        } catch (error) {
          return "";
        }
      },
      set(v) {
        this.item.sysData = app.setRule(this.item.sysData, "sc", v ? v.idx : "");
      },
    },
    email: {
      get() {
        try {
          return app.getRule(this.item.sysData, "eml", "");
        } catch (error) {
          return "";
        }
      },
      set(v) {
        this.item.sysData = app.setRule(this.item.sysData, "eml", v ? v : "");
      },
    },
  },
  methods: {
    generatePass() {
      if (this.clone) {
        this.item = { ...this.item, password: password.generate(8) };
        this.show2 = true;
      }
    },
    erase() {
      this.$store
        .dispatch("admin/DEL_USER", this.item)
        .then(() => {
          this.$emit("delete", this.item);
          this.close();
        })
        .catch((error) => {
          this.showAlertMessage(error);
        });
    },
    close() {
      this.$emit("input", false);
    },
    save() {
      if (!this.$refs.form.validate()) return;
      let params = {
        id: this.item.id,
        additional: this.item.additional,
        password: this.item.password,
        userGroup: this.item.userGroup,
        status: this.item.status,
        sysdata: this.item.sysData,
      };
      app
        .update(this.record.id, rec_type, params)
        .then(() => {
          this.item.rec_type = rec_type;
          if (this.clone && this.item.id != this.record.id) {
            this.$store.commit("admin/insert_user", this.item);
            this.$emit("insert", this.item);
          }
          if (this.group) {
            this.$store.commit("admin/remove_user", this.record);
            this.$store.commit("admin/insert_user", this.item);
            this.$emit("switch", this.item);
          }
          this.close();
        })
        .catch((error) => {
          console.log(error);
          this.showAlertMessage(error);
        });
    },
    showAlertMessage(m) {
      if (m.errorMsg) {
        this.alertMessage = this.$t("error." + m.errorMsg);
      } else {
        this.alertMessage = JSON.stringify(m);
      }
      this.showAlert = true;
      setTimeout(() => {
        this.showAlert = false;
      }, 4000);
    },
  },
};
</script>

<style scoped></style>
